<template>
  <div class="mit-computing-page mit-page">
      <v-container fluid>
      <v-row no-gutters>
        <v-col cols="12" class="d-flex">
          <v-card class="mit-info-card">
            <v-card-title>Computing</v-card-title>
            <v-card-subtitle class="caption">CSAIL Computing Information</v-card-subtitle>
            <v-divider></v-divider>
            <v-card-text>
              <h3 class="pt-5">
                <a href="https://cloud-registration.csail.mit.edu" target="_blank">
                   OpenStack Cloud Password Change
                </a>
              </h3>
              <p>Manage your OpenStack cloud account and password</p>

              <h3 class="pt-5">
                <a href="https://horizon.csail.mit.edu" target="_blank">
                   OpenStack Cloud Application
                </a>
              </h3>
              <p>Manage your OpenStack virtual machines here.</p>

            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>

  export default {
    name: 'MitComputingPage',
    components: {
    },
    data: function() {
      return {
      }
    },
    mounted() {
    },
    methods: {
      // exampleFunction: function(model) {
      //   console.log(model);
      // }
    }
  }
</script>

<style lang="scss" scoped>
  .mit-info-card {
    width:100%;
    height:100%;
  }
</style>
